---
title: "Zerodur Mirror Blanks Complete"
date: 2025-12-22
category: "Engineering"
---

Our Zerodur mirror blanks have been completed and handed off to our optical fabrication partner for grinding and polishing. This marks a major milestone in our telescope program—we now have flight-quality glass in work.

![Zerodur blank](/images/blog-zerodur-blanks/zerodur-blank-1.jpg)

## Why Zerodur?

Zerodur is a glass-ceramic with an extremely low coefficient of thermal expansion. As temperatures change in orbit, Zerodur maintains its shape, keeping the telescope's optical system in alignment. It's the material of choice for precision space optics.

## What's Next

With blanks in hand, our optical partner begins the precision work of grinding and polishing. This process takes time—you can't rush optics—but we're on track to have finished mirrors by July 1, setting our pace to be ready for integration.
